import { inject, Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  APP_CONFIG,
  ProfileService,
  StorageService,
  UrlHelper,
} from '@app-utils';
import { environment } from '../../../../main-app/src/environments/environment';

/**
 * Auth Interceptor
 */
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private readonly _environmentConfig = inject(APP_CONFIG);
  private readonly _storage = inject(StorageService);
  private readonly _profile = inject(ProfileService);

  /**
   * @param request
   * @param next
   */
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    let extendBaseUrl = this._environmentConfig.apiBase.toString() + '/';
    if (
      request.url.includes('.amazonaws.com') ||
      request.url.endsWith('countries.json') ||
      request.url.endsWith('states.json') ||
      request.url.endsWith('cities.json')
    ) {
      extendBaseUrl = '';
    }
    let modifiedRequest = request.clone({
      url: `${extendBaseUrl}${request.url}`,
      setHeaders: {
        'ngrok-skip-browser-warning': 'true',
      },
    });
    let url = request.url;
    let token = this._storage.getAuthToken();

    if (request.url.includes('.amazonaws.com')) {
      token = '';
    }

    const org = this._profile.latestOrganization();
    if (org) {
      url = UrlHelper.buildUrl(url, {
        orgId: org.id,
      });
    }

    const user = this._profile.latestProfile;
    if (user) {
      url = UrlHelper.buildUrl(url, {
        userId: user.id,
      });
    }

    // let username = '';
    // let sessionId = '';
    let userId = '';
    if (token) {
      const dec = this._storage.getDetailFromToken();
      userId = 'userId' in dec ? (dec.userId || '').toString() : '';
    }
    // if (token && environment.local && extendBaseUrl.includes('ngrok')) {
    //   try {
    //     const dec = this._storage.getDetailFromToken();
    //     username = 'username' in dec ? (dec.username || '').toString() : '';
    //     sessionId = 'sessionId' in dec ? (dec.sessionId || '').toString() : '';
    //     userId = 'userId' in dec ? (dec.userId || '').toString() : '';
    //   } catch (e) {
    //     console.error(e);
    //   }
    // }

    if (token) {
      const orgIdExistInHeader = modifiedRequest.headers.has('orgId');
      modifiedRequest = modifiedRequest.clone({
        url: `${extendBaseUrl}${url}`,
        setHeaders: extendBaseUrl
          ? {
              Authorization: `Bearer ${token}`,
              ...(org && !orgIdExistInHeader ? { 'x-org-id': org.id } : {}),
              ...(userId ? { 'X-User-Id': userId } : {}),
              // ...(environment.local &&
              // extendBaseUrl.includes('ngrok') &&
              // username
              //   ? { username, 'X-session-ID': sessionId, 'X-user-ID': userId }
              //   : {}),
            }
          : {},
      });
    }
    return next.handle(modifiedRequest);
  }
}
